import { Link } from 'react-router-dom';
import { getFeaturedProducts } from '@/mocks/products';

export default function FeaturedProducts() {
  const featuredProducts = getFeaturedProducts();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              匠心之作，值得珍藏
            </p>
          </div>
          <Link
            to="/category/gongyi-baijian"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-shadow hover:shadow-lg"
              data-product-shop
            >
              <div className="aspect-square w-full overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  {product.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-1 line-clamp-1">
                  {product.name}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{product.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-lg font-semibold text-accent-600">
                    &yen;{product.price.toLocaleString()}
                  </span>
                  <span className="text-xs text-foreground-400">{product.material}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}